import { render, staticRenderFns } from "./SupplementItem.vue?vue&type=template&id=a4bc524a&scoped=true&"
import script from "./SupplementItem.vue?vue&type=script&lang=js&"
export * from "./SupplementItem.vue?vue&type=script&lang=js&"
import style0 from "./SupplementItem.vue?vue&type=style&index=0&id=a4bc524a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bc524a",
  null
  
)

export default component.exports